import moment from 'moment'
import * as React from 'react'
import { Button } from 'reactstrap'
import * as Actions from './actions'
import './styles.css'
import * as Types from './types'

interface DateLinkState {
  action: Actions.DatedInformationActionCreator,
  community: Types.CommunityIdentifier,
  date: Types.SelectedDate,
  label?: string,
}

interface DateLinksState {
  action: Actions.DatedInformationActionCreator,
  community: Types.CommunityIdentifier,
  date: Types.SelectedDate,
}

export const DateLink = ({community, date, action, label}: DateLinkState) =>
  <Button className="date-selector"
          disabled={date >= moment(new Date())}
          onClick={(() => {action(community, date)})}>
    {label || date.format('YYYY-MM-DD')}
  </Button>

export const DateLinks = ({community, date, action}: DateLinksState) =>
<span>
  <DateLink community={community}
            date={moment(date).subtract(1, 'week')}
            label="<<"
            action={action} />
  <DateLink community={community}
            date={moment(date).subtract(1, 'days')}
            label="<"
            action={action} />
  <DateLink community={community}
            date={moment(date).add(1, 'days')}
            label=">"
            action={action} />
  <DateLink community={community}
            date={moment(date).add(1, 'week')}
            label=">>"
            action={action} />
  <DateLink community={community}
            date={moment(new Date())}
            label="Today"
            action={action} />
</span>



// WEBPACK FOOTER //
// ./src/components/date-selector/component.tsx